/**
 * @file   src\Pages\MarketingPackage.tsx
 * @brief  Marketing Package page.
 * @date   JUL, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React, Container, Breadcrumb, Button, useOutletContext, useNavigate, useEffect, useState } from '../utils/thirdpartyComponents';
import AddIcon from '../assets/images/icons/addicon';
import Packageicon from '../assets/images/package.svg';
import { pageURLs } from '../utils/pageUrls';
import { AppContextType } from '../interfaces/generalInterface';
import SmallLoader from '../components/SmallLoader';
import axios from '../config/axiosConfig';
import { PackageApi } from '../utils/apiUrls';
import { PackageItem } from '../interfaces/packageInterface';

const MarketingPackage = () => {

    // Access the context
    const { data, updateData } = useOutletContext<AppContextType>();

    const [packages, setPackages] = useState<PackageItem[]>([])
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate()

    useEffect(() => {
        // List package
        getPackages()
        handleUpdate()
    }, [])

    const getPackages = async () => {
        try {
            setLoading(true)
            const { data } = await axios.get(PackageApi.LIST_PACKAGE);
            if (data?.error === 0 && Array.isArray(data?.data)) {
                const package_list = data.data;
                if (package_list.length > 0) {
                    setPackages(package_list);
                } else {
                    console.log('Package list is empty');
                    setPackages([]);  // Set to an empty array if location_list is empty
                }
            } else {
                console.log('Package list is not available or is not an array');
                setPackages([]);  // Set to an empty array if data is not available
            }

        } catch (error: any) {
            console.error('Error fetching company list:', error.message);
            throw new Error(error.response?.data?.message || error.message);
        }
        finally {
            setLoading(false); // Hide loader
        }
    }

    // Update the data
    const handleUpdate = async () => {
        await updateData({ heading: "Marketing Package", url: `/superadmin/${pageURLs.manage_hardware}`, showBackButton: true, showMainMenu: true, activeLink: "manage-hardware" });
    };

    // Navigate accordung to url
    const itemClick = async (url: string) => {
        navigate(url);
    }

    return (

        <div className='hardware-listing-container'>
            <Container>
                <div className="nav-btn-title-sec d-flex justify-content-between align-items-center">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_hardware}`) }}>Hardware Listing</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => { itemClick(`/superadmin/${pageURLs.manage_hardware}`) }}> Manage Hardware</Breadcrumb.Item>
                        <Breadcrumb.Item active>Marketing Package</Breadcrumb.Item>
                    </Breadcrumb>
                    <Button
                        type="submit"
                        title="Add New Package"
                        variant="primary"
                        className="primary-btn d-flex align-items-center add-btn"
                        onClick={() => navigate(`/superadmin/${pageURLs.addnew_package}`)}
                    >
                        Add New Package
                        <AddIcon />
                    </Button>
                </div>
                <h6 className='f-bold title'>Marketing Package </h6>
                <div className="hardware-list-wrap">
                    <div className="device-list-group d-flex justify-content-center mx-auto">
                        {packages.map((item) => (
                            <div className="product-card text-center">
                                <div className={item.packageImage ? "device-frame device-img d-flex align-items-center justify-content-center" : "device-frame d-flex align-items-center justify-content-center"}>
                                    <img src={item.packageImage ? `${process.env.REACT_APP_S3_URL_PUBLIC_PATH || ""}${item.packageImage}` : Packageicon} alt={item.packageName} />
                                </div>
                                <h5 className='f-bold'>{item.packageName}</h5>
                                <h2 className='f-bold'>{item.packagePrice}</h2>
                                <p className='f-medium'>{item.packageDesc}</p>
                                <Button variant="primary" title="Edit" className="primary-btn" onClick={() => navigate(`/superadmin/${pageURLs.edit_package}/${item.packageId}`)}>Edit</Button>
                            </div>
                        ))}


                    </div>
                </div>
            </Container >
            {loading && <SmallLoader />}

        </div >
    )
}

export default MarketingPackage;
